import React from "react";
import "./LoaderLogo.css";

class LogoLoader extends React.Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        className="raw_logo"
        width="50%"
        height="40%"
        viewBox="0 0 440 305"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Animated Hexagon Outline */}
        <polygon
          className="myHexagon"
          points="220,35 295,78 295,165 220,208 145,165 145,78"
          stroke={theme.body}
          strokeWidth="5"
          fill="none"
        />

        {/* Center Initials: MZS */}
        <text
          x="50%"
          y="128"
          className="letter"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={theme.body}
          fontSize="52"
          fontWeight="bold"
          fontFamily="sans-serif"
          letterSpacing="2"
        >
          MZS
        </text>

        {/* Full Name Underneath */}
        <text
          x="50%"
          y="255"
          className="signatureName"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={theme.body}
          fontSize="18"
          fontWeight="600"
          fontFamily="sans-serif"
          letterSpacing="3"
        >
          MOHAMMAD ZAID SHAIKH
        </text>

        <defs>
          <style
            dangerouslySetInnerHTML={{
              __html: `
		.myHexagon {
			stroke-dasharray: 800;
			stroke-dashoffset: 800;
			animation: dash 2.5s linear forwards 0.2s;
		}

		.letter {
			opacity: 0;
			animation: fadein 1.2s ease-in forwards 1.0s;
		}

		.signatureName {
			opacity: 0;
			animation: fadein 1.2s ease-in forwards 1.6s;
		}

		@keyframes fadein {
			from { opacity: 0; transform: translateY(5px); }
			to { opacity: 1; transform: translateY(0); }
		}

		@keyframes dash {
			from { stroke-dashoffset: 800; }
			to { stroke-dashoffset: 0; }
		}
    `,
            }}
          />
        </defs>
      </svg>
    );
  }
}

export default LogoLoader;
